module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Unlock-8b523c683e4a5f93904aff258bb67a76.svg";